import { Button } from '@sr/ui-library';
import { Link } from 'react-router-dom';
import { EntityList } from './EntityList';

interface SnapshotViewAllProps {
  to: string;
  total: number;
  visibleCount: number;
}

/**
 * "View All" link for a Home section, shown once that section holds more
 * items than Home displays. Renders nothing when the section already shows
 * everything.
 */
export const SnapshotViewAll = ({
  to,
  total,
  visibleCount,
}: SnapshotViewAllProps) => {
  if (total <= visibleCount) return null;

  return (
    <EntityList.Actions>
      <Button asChild className="text-destructive" size="sm" variant="ghost">
        <Link to={to}>View All</Link>
      </Button>
    </EntityList.Actions>
  );
};
